import { render, staticRenderFns } from "./portal-quick-adder.vue?vue&type=template&id=2828e438&"
import script from "./portal-quick-adder.vue?vue&type=script&lang=js&"
export * from "./portal-quick-adder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports